import React from "react";
// import Sidebar from "../global/sidebar";
import Box from "@mui/material/Box";
import Dashboard from "../../components/dashboardComponents";

export function DashboardPage() {
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Dashboard />
        </Box>
      </Box>
    </>
  );
}

